export const SEARCH_CAMPSITES = 'SEARCH_CAMPSITES';
export const GET_CAMPSITE = 'GET_CAMPSITE';
export const CLEAR_CAMPSITES = 'CLEAR_CAMPSITES';
export const GET_REPOS = 'GET_REPOS';
export const SET_LOADING = 'SET_LOADING';
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const SET_MIN_TEMP = 'SET_MIN_TEMP';
